module.exports = __webpack_public_path__ + "static/media/organization-un.d2ccd5bd.svg";